import { render, staticRenderFns } from "./TileProductThroughputPerMinute.vue?vue&type=template&id=647aaa7d"
import script from "./TileProductThroughputPerMinute.vue?vue&type=script&lang=js"
export * from "./TileProductThroughputPerMinute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports